var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0046 6.41961H4.81804V5.1104C4.81804 3.32638 6.30005 1.87413 8.12265 1.87413C9.94526 1.87413 11.4273 3.32837 11.4273 5.11437C11.4273 5.35675 11.6259 5.55144 11.8733 5.55144C12.1206 5.55144 12.3193 5.35675 12.3193 5.11437C12.3193 2.84561 10.4359 1 8.12265 1C7.00152 1 5.94729 1.42713 5.15459 2.20392C4.36188 2.9807 3.926 4.01178 3.926 5.1104V6.41961H2.9853C2.43791 6.41961 2 6.84873 2 7.38314V14.0206C2 14.557 2.43994 15 2.9853 15H13.0025C13.5499 15 14 14.557 14 14.0206V7.38314C14.002 6.84873 13.5519 6.41961 13.0046 6.41961ZM13.11 14.0305C13.11 14.0841 13.0654 14.1279 13.0106 14.1279H2.99138C2.93664 14.1279 2.89204 14.0841 2.89204 14.0305V7.39109C2.89204 7.33745 2.93664 7.29374 2.99138 7.29374H13.0086C13.0633 7.29374 13.108 7.33745 13.108 7.39109V14.0305H13.11ZM7.91992 8.6844C7.4151 8.6844 7.0076 9.08372 7.0076 9.5784C7.0076 9.90421 7.18601 10.1903 7.45362 10.3472V12.0816C7.45362 12.322 7.65433 12.5187 7.89964 12.5187C8.14495 12.5187 8.34566 12.322 8.34566 12.0816V10.3691C8.63558 10.2201 8.83223 9.92209 8.83223 9.5784C8.83223 9.08372 8.42473 8.6844 7.91992 8.6844Z",
    fill: "#2469EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwd);
export default __webpack_public_path__ + "static/media/pwd.3371dd1ea3ccdd710ad2a090bf30a8cd.svg";
export { ForwardRef as ReactComponent };